import { TimeAggregationEnum } from '@common-modules/shared/model/algorithm/time-aggregation.enum';
import { ElementTargetsEnum } from '@common-modules/shared/model/shared/element-targets.enum';

export class AlgorithmFilterItemQuery {
  targetIds?: ElementTargetsEnum[];
  timeAggregationIds?: TimeAggregationEnum[];

  constructor(init: AlgorithmFilterItemQuery) {
    Object.assign(this, init);
  }
}
